<template>
  <el-dialog v-dialogDrag :title="messageDialogTitle" :visible.sync="messageDialogVisible" v-if="messageDialogVisible" width="600px">
    <div class="dialog-form">
      <el-row>{{systemMessageDetail.messageTitle}}</el-row>
      <br>
      <el-row>{{systemMessageDetail.messageDescription}}</el-row>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="mini" @click="refreshParsent()">确定</el-button>
      <el-button size="mini" v-if="show" @click="selectDetail()">查看详情</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "systemMessage_detail",
    mounted() {
      this.eventBus.$on('showMessageDetail', (systemMessage) => {
        //如果url不为空，先根据？拆分，再根据=拆分
        if(systemMessage.detailUrl!=null && systemMessage.detailUrl!=''){
          this.show = true;
          this.url = systemMessage.detailUrl.split('?')[0];
          // 根据url构造路由参数
          this.queryParam = this.handleQueryParam(systemMessage.detailUrl);
        }
        this.messageDialogTitle="系统消息"+systemMessage.creationTime;
        this.messageDialogVisible = true;
        this.systemMessageDetail = systemMessage
      })
    },
    data() {
      return {
        queryParam: undefined, // 路由参数

        url:'',//跳转详情页面的路径
        show:false,
        messageDialogTitle: "",
        messageDialogVisible: false,
        systemMessageDetail: undefined
      }
    },
    methods: {
      refreshParsent(){
        this.messageDialogVisible = false
      },
      selectDetail(){
        //路由跳转到详情页
        this.$router.push({
          path: this.url,
          query: this.queryParam
        })
      },
      /**
       * 根据url构造路由参数
       * @param url
       * @returns {{}}
       *
       * 例子1：url="/admin/settlement/orderTask/list?taskId=1"    返回值：{taskId: "1"}
       * 例子2：url="/admin/settlement/orderTask/list?taskId=1&&projectId=2"    返回值：{taskId: "1", projectId: "2"}
       */
      handleQueryParam(url) {
        let urlParam = url.indexOf("?") > -1 ? url.split("?")[1] : url;
        let routerQuery = {};
        if(urlParam.indexOf("&&") > -1) {
          let paramParts = urlParam.split("&&");
          for (let i=0; i<paramParts.length; i++) {
            let part = paramParts[i];
            routerQuery[part.split("=")[0]] = part.split("=")[1]
          }
        } else {
          routerQuery[urlParam.split("=")[0]] = urlParam.split("=")[1]
        }
        return routerQuery
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/home/enterprise/systemMessage_detail.vue